import { NewsletterSingleInterface } from 'modules/newsletters/single/types/newsletter-interface'
import { getNewslettersEditorNextjsUrl } from 'modules/newsletters/single/utils/get-newsletters-editor-nextjs-url'
import React from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { TLocoType } from 'shared/hooks/use-loco-translation'

export const getNewsletterSingleColumnTitle = (
  newsletter: NewsletterSingleInterface,
  t: TLocoType,
) => {
  return (
    <div className={'truncate'}>
      <LinkWithoutPrefetch
        className="primary-link w-full"
        href={getNewslettersEditorNextjsUrl(newsletter.id)}
      >
        {newsletter.mailing.currentEmail.subject}
      </LinkWithoutPrefetch>
      {newsletter.excludeRecipientsOfNewsletter && (
        <p className="truncate">
          {t('dashboard.newsletter.resend_after_title')}:{' '}
          {newsletter.excludeRecipientsOfNewsletter.removedAt ? (
            <span>{newsletter.excludeRecipientsOfNewsletter.mailing.currentEmail.subject}</span>
          ) : (
            <LinkWithoutPrefetch
              className="primary-link w-full"
              href={getNewslettersEditorNextjsUrl(newsletter.excludeRecipientsOfNewsletter.id)}
            >
              {newsletter.excludeRecipientsOfNewsletter.mailing.currentEmail.subject}
            </LinkWithoutPrefetch>
          )}
        </p>
      )}
    </div>
  )
}
